<span [innerHTML]="sanitizedIcon" ></span>
